import { render, staticRenderFns } from "./IssueTypeOption.vue?vue&type=template&id=0fdd05b5&scoped=true&"
import script from "./IssueTypeOption.vue?vue&type=script&lang=ts&"
export * from "./IssueTypeOption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdd05b5",
  null
  
)

export default component.exports